import { Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular/standalone';
import { OverlayEventDetail } from '@ionic/core';

import { MobileService } from '../mobile/mobile.service';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private initialBreakpoint: number | undefined = 1;

  constructor(
    private mobileService: MobileService,
    private modalController: ModalController
  ) {
    this.mobileService.mobile$.subscribe((mobile) => {
      this.initialBreakpoint = mobile ? 1 : undefined;
    });
  }

  public async openModal(
    id: string,
    cssClass: string,
    component: Function,
    breakpoints: boolean = true,
    data?: any,
    callback?: any
  ): Promise<OverlayEventDetail<any>> {
    const modal = await this.modalController.create({
      id: id,
      cssClass: `modal ${cssClass}`,
      component: component,
      canDismiss: true,
      initialBreakpoint: breakpoints ? this.initialBreakpoint : undefined,
      breakpoints: breakpoints ? [0, 1] : undefined,
      componentProps: data,
    });


    await modal.present();
    return await modal.onDidDismiss().then(callback);
  }

  public async dismiss(action: any = null): Promise<boolean> {
    return await this.modalController.dismiss(action);
  }

  public async hasModal(): Promise<HTMLIonModalElement | undefined> {
    return await this.modalController.getTop();
  }
}
